<template>
  <div id="appointmentCreate">
    <v-form v-model="valid">
      <h1 class="header-text">
        <span>
          Novi termin
          <div class="header-text-line"></div>
        </span>
      </h1>
      <v-layout row wrap>
        <!-- <FIXED APPOINTMENT CHECKBOX> -->
        <v-flex xs12 sm6 v-if="windowWidth > 768">
          <v-checkbox label="Fiksni termin" v-if="isAdministratorCreate" v-model="isFixed"></v-checkbox>
        </v-flex>
        <!-- </FIXED APPOINTMENT CHECKBOX> -->

        <!-- <DAY OF THE WEEK SELECT> -->
        <v-flex xs12 sm6>
          <v-select
            label="Dan/i"
            :items="daysOfTheWeek"
            v-model="selectedDays"
            :rules="rules.required"
            item-text="Name"
            item-value="Value"
            v-if="isFixed"
            multiple
            chips
          ></v-select>
        </v-flex>
        <!-- </DAY OF THE WEEK SELECT> -->

        <!-- <TIME PICKER> -->
        <v-flex xs6 sm3>
          <p>Time from:</p>
          <vue-timepicker class="time-picker" v-model="timeFrom" :minute-interval="5"></vue-timepicker>
        </v-flex>
        <v-flex xs6 sm3>
          <p>Time to:</p>
          <vue-timepicker class="time-picker" v-model="timeTo" :minute-interval="5"></vue-timepicker>
        </v-flex>
        <!-- </TIME PICKER> -->

        <!-- <SINGLE DATE> -->
          <!-- neki komentar-->
        <v-flex xs12 sm6 v-if="!isFixed">
          <v-menu
            ref="menu"
            :close-on-content-click="true"
            v-model="menu"
            :nudge-right="40"
            :return-value.sync="appointment.Date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="appointment.Date"
              label="Datum"
              :rules="rules.required"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="appointment.Date"
              @input="$refs.menu.save(appointment.Date)"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <!-- </SINGLE DATE> -->

        <!-- <ADMIN DATE> -->
        <v-layout row v-else>
          <v-flex xs6>
            <v-menu
              ref="menu"
              :close-on-content-click="true"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="dateFrom"
              lazy
              transition="scale-transition"
              offset-y
              full-width
            >
              <v-text-field
                slot="activator"
                v-model="dateFrom"
                :rules="rules.required"
                label="Datum od"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="dateFrom"
                @input="$refs.menu.save(dateFrom)"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-menu
              ref="menu2"
              :close-on-content-click="true"
              v-model="menu2"
              :nudge-right="40"
              :return-value.sync="dateTo"
              lazy
              transition="scale-transition"
              offset-y
              full-width
            >
              <v-text-field
                slot="activator"
                v-model="dateTo"
                :rules="rules.required"
                label="Datum do"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="dateTo" @input="$refs.menu2.save(dateTo)" no-title scrollable></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <!-- </ADMIN DATE> -->

        <!-- <STUDIO SELECT> -->
        <v-flex xs12>
          <v-select
            label="Select studio"
            v-model="appointment.StudioId"
            :items="studio"
            item-text="Name"
            item-value="StudioId"
          ></v-select>
        </v-flex>
        <!-- </STUDIO SELECT> -->

        <!-- TODO: uklonjen v-if="isAdministratorCreate" -->
        <!-- <APPOINTMENT TYPE SELECT> -->
        <v-flex xs12>
          <v-select
            label="Select appointment type"
            v-model="appointment.AppointmentTypeId"
            :items="appointmentType"
            :rules="rules.required"
            item-text="Name"
            item-value="AppointmentTypeId"
          ></v-select>
        </v-flex>
        <!-- </APPOINTMENT TYPE SELECT> -->

        <!-- <ADD USERS> -->
        <v-flex xs12>
          <v-autocomplete
            v-model="appointment.AppointmentUsers"
            :items="users"
            box
            chips
            color="blue-grey lighten-2"
            label="Select"
            item-text="Name"
            item-value="UserId"
            multiple
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeUser(data.item)"
              >
                <v-avatar>
                  <img :src="data.item.ProfileUrl">
                </v-avatar>
                {{ data.item.Name }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <img :src="data.item.ProfileUrl">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.Name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </v-flex>
        <!-- </ADD USERS> -->

        <!-- <CREATE BUTTON> -->
        <v-flex xs12>
          <v-btn :disabled="!valid" color="primary" @click="postAppointment">Kreiraj</v-btn>
        </v-flex>
        <!-- </CREATE BUTTON> -->
      </v-layout>
    </v-form>
  </div>
</template>
<script>
import VueTimepicker from "vue2-timepicker";
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  components: {
    VueTimepicker
  },
  props: ["windowWidth"],
  data() {
    return {
      appointment: {
        Date: null,
        AppointmentUsers: []
      },
      //Validation
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"]
      },
      isFixed: false,
      //If(isfixed){
      daysOfTheWeek: [
        {
          Name: "Ponedjeljak",
          Value: 1
        },
        {
          Name: "Utorak",
          Value: 2
        },
        {
          Name: "Srijeda",
          Value: 3
        },
        {
          Name: "Četvrtak",
          Value: 4
        },
        {
          Name: "Petak",
          Value: 5
        },
        {
          Name: "Subota",
          Value: 6
        },
        {
          Name: "Nedjelja",
          Value: 0
        }
      ],
      selectedDays: [],
      dateFrom: null,
      dateTo: null,
      //}

      //For selecting users
      users: [],
      //If true addition options are included
      isAdministratorCreate: false,
      timeTo: {
        HH: "09",
        mm: "00"
      },
      timeFrom: {
        HH: "08",
        mm: "00"
      },
      studio: [],
      appointmentType: [],

      //FOR DATE PICKERS
      menu: false,
      menu2: false
    };
  },
  methods: {
    getStudio() {
      this.$store.state.services.studioService.getForDropdown().then(response => {
        this.studio = response.data;
      });
    },
    getUsers() {
      if (this.isAdministratorCreate) {
        this.getProfesors();
      } else {
        this.getAttendends();
      }
    },
    getProfesors() {
      let self = this;
      this.$store.state.services.userService.profesorsList().then(response => {
        self.users = response.data;
        self.users.unshift({ header: "Profesori" });
        self.users.push({ divider: true });
        self.getAttendends();
      });
    },
    getAttendends() {
      let self = this;
      this.$store.state.services.userService.attendendsList().then(response => {
        var attendends = [];
        attendends = response.data;
        attendends.unshift({ header: "Polaznici" });
        self.users.push.apply(self.users, attendends);
      });
    },
    getAppointmentType() {
      this.$store.state.services.appointmentTypeService
        .getAll()
        .then(response => {
          this.appointmentType = response.data;
        });
    },
    postAppointment() {
      var appointment = Object.assign({}, this.appointment);
      var tf = this.timeFrom;
      var tt = this.timeTo;
      appointment.TimeFrom = tf.HH + ":" + tf.mm;
      appointment.TimeTo = tt.HH + ":" + tt.mm;

      //Appointment users
      var appointmentUsers = [];
      appointment.AppointmentUsers.forEach(element => {
        let createdByUser = false;
        if (element === parseInt(localStorage.getItem("user"))) {
          createdByUser = true;
        }
        appointmentUsers.push({
          UserId: element,
          CreatedByUser: createdByUser
        });
      });
      appointment.AppointmentUsers = appointmentUsers;

      var appointmentVM = {};
      if (this.isFixed) {
        //Temp solution for filling date
        appointment.Date = this.$moment(this.dateFrom).format("MM-DD-YYYY");
        appointmentVM = {
          IsFixed: this.isFixed,
          SelectedDays: this.selectedDays,
          DateFrom: this.$moment(this.dateFrom).format("MM-DD-YYYY"),
          DateTo: this.$moment(this.dateTo).format("MM-DD-YYYY"),
          Appointment: appointment
        };
      } else {
        appointment.Date = this.$moment(appointment.Date).format("MM-DD-YYYY");
        appointmentVM = {
          IsFixed: false,
          Appointment: appointment
        };
      }
      this.$store.state.services.appointmentService
        .add(appointmentVM)
        .then(response => {
          this.$emit("createAppointment");
          this.$emit("showResponseMessage", response.data);
          this.appointment = {
            Date: null,
            AppointmentUsers: []
          };
        });
    },
    
    //Deleting user from user selection
    removeUser(item) {
      if(item.UserId === parseInt(localStorage.getItem("user"))){
        return;
      }
      const index = this.appointment.AppointmentUsers.indexOf(item.UserId);
      if (index >= 0) this.appointment.AppointmentUsers.splice(index, 1);
    },
    setLogedUser() {
      this.appointment.AppointmentUsers.push(
        parseInt(localStorage.getItem("user"))
      );
    }
  },
  created() {
    this.getStudio();
    this.getAppointmentType();
    //Checking if is administrator because user selection is not the same for administrator like it's for attendens and profesors
    this.isAdministratorCreate = this.$store.state.services.checkRole(
      "Administrator"
    );
    this.getUsers();
    this.setLogedUser();
  }
};
</script>
<style scoped>
/* .time-picker {
  width: 100%;
  padding: 0 5px;
} */
.display-time {
  width: 100% !important;
}
.header-text {
  margin-bottom: 20px;
}
</style>
